import { Box, Skeleton } from "@mui/material"
import PatientDetails from "./PatientDetails"
import TabsDetail from "./TabsDetail"
import { useDispatch, useSelector } from "react-redux"
import { getPatientDetailsById } from "../../../../slices/QRCode"
import { useParams } from "react-router"
import { useEffect, useState, useRef } from "react"
import { fetchV2V, setCoaFormData, clearCoaFormData,selectFollowCycle, storePatientData } from "../../../../slices/common"
import { dateFormater } from "../../../../utils/common/utils"
import { getCoaFormDetailsById } from "../../../../slices/qualityControl";
import SubjectApi from "../../../../../services/subjectService"
import moment from "moment"
import {capitalizeWords} from "../../../../../utils/utils"

  const getPhaseLabels = (phaseType) => {
    const isCommercial = phaseType === "Commercial";
    return {
      patientLabel: isCommercial ? "Patient " : "Subject",
      hospitalLabel: isCommercial ? "Hospital" : "Site",
      personLabel: isCommercial ? "HCP" : "Principal Investigator",
    };
  };

const ViewDetails = () => {
  const dispatch = useDispatch();
  const [patientData, setPatientData] = useState({});
  const [subjectData, setSubjectData] =useState([])
  const [cycleData, setCycleData] = useState([]);
  const [patientInfo, setPatientInfo] = useState({});
  const currentCycle = useSelector(selectFollowCycle)
  const [timeLineSkeletonLoading, setTimeLineSkeletonLoading] = useState(false);
  const [isSubjectLoading, setIsSubjectLoading] = useState(false);
  const [qrCodeDataUrl, setQrCodeDataUrl] = useState('');
  const qrRef = useRef(null);
  const [patientMedicalInfo, setPatientMedicalInfo] = useState({});
 const [callTimeLineApi, setCallTimeLineApi] = useState(false)
  const initialized = useRef(false);
  const [selectedCycleIndex, setSelectedCycleIndex] = useState(0);
  const { qrId } = useParams()
   const [ids, setIds] = useState(qrId)
   const phaseLabels = getPhaseLabels(patientData?.phase_type);
  /* ===================== SUBJECT ===================== */
  const fetchSubjectDetail = async (id) => {
    try {
      const res = await SubjectApi.getSubjectDetails(
        id ?? patientData?.patient_information?.id
      );
      return res?.data;
    } catch (err) {
      console.error(err);
    }
  };

      useEffect(() => {
    if (callTimeLineApi) {
      setCallTimeLineApi(false)
      getTimeLine(patientData?.patient_information?.id);
    }
  }, [callTimeLineApi]);

  
  const fetchPatientDetail = async (qrId= currentCycle?.qr_code_generation_id) => {
   setIsSubjectLoading(true)
   if(!qrId) return
    try {
      const patientDetailsResponse = await dispatch(
        getPatientDetailsById({id:qrId, prodmfg:currentCycle?.product_manufacturing_id})
      ).unwrap();

      const patientDetails = patientDetailsResponse?.data?.patient_information;
       const isBagCount = patientDetailsResponse?.data?.number_of_bags || 0;

      const patientBasicInfo = {
        patientName: patientDetails?.name || "-",
        phase_type: patientDetailsResponse?.data?.phase_type,
        patientInitials: patientDetails?.patient_initials,
        patientId: patientDetails?.patient_id || "-",
        id: patientDetails?.id,
        bagCount: isBagCount,
        qr_code_id: patientDetailsResponse?.data?.id,
        product_id:patientDetailsResponse?.data?.product_id,
        phase_id:patientDetails?.phase_id,
        subject_id: patientDetails?.subject_id || patientDetails?.id,
        feasibility_assessment_id:
          currentCycle?.feasibility_assessments_id || patientDetails?.feasibility_assessment_id,
        inbond_form_id: currentCycle?.inbond_patients_id ?? null,
        hospital_patient_id: patientDetailsResponse?.data?.hospital_patient_id || "",
        logisticOperationId:
          patientDetailsResponse?.data?.logistics_operation_id ?? null,
        immunoactPatientId: patientDetails?.immunoact_patient_id || "-",
        name: patientDetails?.name || "-", // Add name for ReprintComponent
        body_weight: patientDetails?.body_weight || 0, // Add weight for ReprintComponent
        dob: patientDetails?.dob || "-", // Add DOB for ReprintComponent
        disease: patientDetails?.disease || "-", // Add disease for ReprintComponent
        hospital: patientDetails?.hospital || "-", // Add hospital for ReprintComponent
      };
      const labels = getPhaseLabels(patientDetailsResponse?.data?.phase_type);
      const patientMedicalRecord = {
          [`${labels.patientLabel} Body Weight`]: `${patientDetails?.body_weight} kg` || "-",
          "Disease Indication": capitalizeWords(patientDetails?.disease) || "-",
          "Date of Birth": patientDetails?.dob
            ? moment(patientDetails.dob).format("DD/MM/YYYY")
            : "-",
         [`${labels.hospitalLabel} Name`]: patientDetails?.hospital || "-",
          [`${labels.hospitalLabel} Patient ID`]: patientDetailsResponse?.data?.hospital_patient_id || "-",
          "Ship & Store": "2-8 degree celsius",
          "Total no Bags":  isBagCount || 0,
          "Batch ID":  patientDetailsResponse?.data?.batch_no || "-",
        };
       setPatientInfo(patientBasicInfo);
        setPatientMedicalInfo(patientMedicalRecord);

        window.qrGenerationTimeout = setTimeout(() => {
          const canvas = qrRef.current?.querySelector('canvas');
          if (canvas) {
            const dataUrl = canvas.toDataURL('image/png');
            setQrCodeDataUrl(dataUrl);
          }
          // Clear the timeout reference after execution
          window.qrGenerationTimeout = null;
        }, 300);

      // ✅ fetch subject AFTER patient
      const subjectRes = await fetchSubjectDetail(patientDetailsResponse?.data?.patient_information?.id
        // patientDetails?.subject_id || patientDetails?.id
      );
      setSubjectData(subjectRes)
      // ✅ subjectData is now meaningful
     const editors = subjectRes?.userPi || [];
      const data = {
        ...patientDetailsResponse.data,
        life_status: subjectRes?.life_status,
        hospital_name: subjectRes?.investigator?.hospital_details?.name,
        principal_investigator: subjectRes?.investigator?.name,
        editor: editors.length > 1 
                    ? editors.length.toString() 
                    : (editors.length === 1) 
                      ? editors[0]?.name || "--" 
                      : "--"

      };
      setIsSubjectLoading(false)
      setPatientData(data);
      setPatientInfo(patientBasicInfo)
      // setPatientData(patientDetailsResponse.data)
      dispatch(storePatientData(patientDetailsResponse))
    } catch (error) {
      console.error('Error', error)
    }
    finally{
setIsSubjectLoading(false)

    }
  }

  useEffect(() => {
    if (currentCycle) {
      setPatientMedicalInfo((prev) => ({
        ...prev,
        "Total no Bags": currentCycle?.no_of_bags || 0,
        "Batch ID": currentCycle?.batch_no
      }));
    }
  }, [currentCycle]);

  useEffect(() => {
      if (!currentCycle?.coa_forms_id){  dispatch(clearCoaFormData());return}
    fetchCoaForms(currentCycle?.coa_forms_id, patientData)
  }, [currentCycle?.coa_forms_id])

  const getTimeLine = async (id) => {
    setTimeLineSkeletonLoading(true);
    try {
      const response = await dispatch(
        fetchV2V({
          portal_type: 2,
          patient_id: id ?? patientData?.patient_information?.id,
        })
      ).unwrap();
      // ✅ adjust based on API shape
      setCycleData(response?.data ?? []);
    } catch (err) {
      console.error(err);
    } finally {
      setTimeLineSkeletonLoading(false);
    }
  }; 

 useEffect(() => {
      if(ids){
    fetchPatientDetail(ids);
    setIds('')
      }
  }, [ids]);


    useEffect(() => {
       if(!ids)
      fetchPatientDetail()
  },[currentCycle?.product_manufacturing_id])

  useEffect(() => {
    if (patientData?.patient_information?.id && cycleData?.length < 1) {
      getTimeLine(patientData?.patient_information?.id);
    }
  }, [patientData,cycleData]);


  const fetchCoaForms = async (coaFormId, patientData) => {
    try {
      const response = await dispatch(
        getCoaFormDetailsById(coaFormId)
      ).unwrap();
      if (response?.data) {
        const dataValues = response?.data
        const preFilledData = {
          product_name: patientData?.product_name || "",
          batch_no: currentCycle?.batch_no || "",
          immunoact_patient_id: patientData?.patientId || "",
          product_id: patientData?.product_id || patientData?.product_id || "",
          product_manufacturing_id: currentCycle?.product_manufacturing_id || "",
          expired_at: patientData.expiry_date ? dateFormater(patientData?.expiry_date):"",
          mfg_date: currentCycle?.mfg_at ? dateFormater(currentCycle?.mfg_at) : "",    
        }
        dispatch(setCoaFormData({ ...dataValues, ...preFilledData }))

      }
    } catch (error) {
      console.error("Error fetching COA form details:", error);
    }
  };
  return (
    <>
      <Box sx={{ p: 4 }}>
        <Box sx={{ mb: 2 }}>
          {isSubjectLoading ? <div className="border rounded-md flex gap-2 flex-col bg-[#F0F1F5] p-3">
            <Skeleton variant="text" width="40%" />
            <Skeleton variant="text" width="60%" />
            <Skeleton variant="text" width="50%" />
          </div> : <PatientDetails selectedCycleIndex={selectedCycleIndex} setSelectedCycleIndex={setSelectedCycleIndex} initialized={initialized} patientInfo={patientInfo} subjectData={subjectData} patientData={patientData} cycleData={cycleData} phaseLabels={phaseLabels}/>}
        </Box>
         {patientData?.patient_information?.id && (
          <TabsDetail
            patientData={patientData}
            patientInfo={patientInfo}
            patientMedicalInfo={patientMedicalInfo}
            timeLineSkeletonLoading={timeLineSkeletonLoading}
            qrCodeDataUrl={qrCodeDataUrl}
            fetchTimeLineApi={() => setCallTimeLineApi(true)}
            phaseLabels={phaseLabels}
          />
        )}
        
      </Box>
    </>
  )
}

export default ViewDetails